// contact.tsx
import React, { Component } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import "../css/home.css";

class Contact extends Component {
  override render() {
    return (
      <Box>
        <Typography variant="h4" align="center" gutterBottom>
          Contact Page
        </Typography>
        <Paper 
          elevation={0} 
          sx={{ 
            p: 3, 
            bgcolor: 'background.paper',
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="body1">
            This is the contact page with enhanced styling.
          </Typography>
        </Paper>
      </Box>
    )
  }
}

export default Contact;